export default "__VITE_ASSET__C9C05iYE__"